import { PortalSection } from "./portal-ui";

interface TeamMember {
  first_name: string;
  last_name: string;
  role?: string;
  type?: string;
}

interface InvestmentTeamCardProps {
  teamMembers?: TeamMember[];
}

/** The people a founder will meet: initials, name and role, in a quiet grid. */
export function InvestmentTeamCard({ teamMembers }: InvestmentTeamCardProps) {
  if (!teamMembers || teamMembers.length === 0) return null;

  // Show role if available, otherwise show access type (capitalized)
  const getDisplayLabel = (member: TeamMember) => {
    if (member.role) return member.role;
    if (member.type) {
      return member.type.charAt(0).toUpperCase() + member.type.slice(1);
    }
    return null;
  };

  return (
    <PortalSection title="The team">
      <ul className="grid gap-x-8 gap-y-5 sm:grid-cols-2">
        {teamMembers.map((member, index) => {
          const displayLabel = getDisplayLabel(member);
          return (
            <li key={index} className="flex min-w-0 items-center gap-3">
              <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-border bg-card text-[12px] font-semibold text-foreground/70">
                {member.first_name?.charAt(0) || ""}
                {member.last_name?.charAt(0) || ""}
              </span>
              <div className="min-w-0">
                <p className="truncate text-[15px] font-medium">
                  {member.first_name} {member.last_name}
                </p>
                {displayLabel && (
                  <p className="truncate text-[13px] text-muted-foreground">{displayLabel}</p>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </PortalSection>
  );
}
